import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { baseHttpUrlInterceptor } from '@coworkrz/core/http';
import {
  AUTH_ACCESS_TOKEN_KEY,
  AUTH_GUARD_REDIRECTION_LINK,
  AUTH_REFRESH_TOKEN_KEY,
  GOOGLE_ACCOUNTS_CLIENT_ID,
  authInterceptor,
  unauthorizedInterceptor,
} from '@coworkrz/auth/data-access';
import { LOCATION_TOKEN } from '@coworkrz/shared/misc';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withEnabledBlockingInitialNavigation()
    ),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        baseHttpUrlInterceptor,
        unauthorizedInterceptor,
      ])
    ),
    {
      provide: AUTH_ACCESS_TOKEN_KEY,
      useValue: process.env['NX_AUTH_ACCESS_TOKEN_KEY'],
    },
    {
      provide: AUTH_REFRESH_TOKEN_KEY,
      useValue: process.env['NX_AUTH_REFRESH_TOKEN_KEY'],
    },
    {
      provide: GOOGLE_ACCOUNTS_CLIENT_ID,
      useValue: process.env['NX_GOOGLE_ACCOUNTS_CLIENT_ID'],
    },
    {
      provide: LOCATION_TOKEN,
      useValue: window.location,
    },
    {
      provide: AUTH_GUARD_REDIRECTION_LINK,
      useValue: '/auth/sign-in',
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
